let api: any;

if (process.env.NODE_ENV === "production") {
  api = require("./api.prod");
} else {
  api = require("./api.dev");
}

export default api.default;
